import { render, staticRenderFns } from "./EditSubcategoryDialog.vue?vue&type=template&id=3a97120e"
import script from "./EditSubcategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditSubcategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports